import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const freshService = defineConnector({
  identifier: "freshService",
  name: "Freshservice",
  tagLine: "IT service management",
  logo,
  protocol: "http",
  tags: ["featured", "it"],
  defaultUrlPattern: () => "https://.*\\.freshservice\\.com/.*",
  auth: (app) =>
    basicAuth({
      username: app.secret.apiKey,
      password: "X",
    }),
  steps: [
    {
      title: "Get your Freshservice API key",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to your Freshservice account. Click your profile picture in the top right corner and select **Profile Settings**. Your API key is displayed under the API Key section.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "hostname",
          label: "Domain",
          required: true,
          placeholder: "yourcompany.freshservice.com",
          target: { kind: "configuration", field: "domain" },
          helperText:
            "Your Freshservice domain (e.g., yourcompany.freshservice.com)",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/api/v2/tickets?per_page=1`,
  },
  publicEnvVars: ({ domain }) => ({
    FRESH_SERVICE_URL: domain ? `https://${domain}` : "",
  }),
});
